import 'jquery';
import 'lightgallery';
import 'lg-thumbnail';
import 'slick-carousel';
import 'modernizr-custom';

import './functions/initApp';